<div class="flex-centered-vr-space-between-container" [ngClass]="{'border-gray-bottom pad-8-vr padding-hr': isDialog}">
    <div class="flex-space-around margin-4-top plans-image-container"
        *ngIf="plansOfferUrls && plansOfferUrls.length; else noOffersHeader">
        <ng-container *ngFor="let image of plansOfferUrls">
            <img [src]="image" class="festival-offer-img">
        </ng-container>
    </div>
    <button *ngIf="isDialog" mat-icon-button aria-label="close dialog" class="close-button" tabindex="-1"
        (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<ng-container *ngIf="!loading; else loader">
    <ng-container *ngIf="!showStatusScreen; else statusScreen">
        <div class="plans-container">
            <div class="plans-card plans-card-static">
                <div class="plans-main display-flex-column">
                    <div class="plans-card-header padding flex-centered-container-vr">
                        <mat-form-field *ngIf="frequencyArray.length > 2; else plansFrequencyRadio"
                            class="condensed-select-field frequency-form-field full-width" appearance="outline">
                            <mat-select [(value)]="selectedTab">
                                <mat-option *ngFor="let frequency of frequencyArray" [value]="frequency">
                                    {{ frequency }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="plans-content-container">
                        <div class="dynamic-font-12 plans-feature-text no-border plan-feature-alignment">
                            Live Deployment
                        </div>
                        <div class="pad-8 dynamic-font-12 plans-feature-text display-flex align-items-center">
                            <img src="/assets/uTrade-Intelligence.svg" class="uTrade-Intelligence-icon"> uTrade
                            Intelligence
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            AI Credits (Per Day)
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            AI Credits (Per Month)
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            Forward Trading
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            uTrade Originals
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            NSE Symbols
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            BSE Symbols
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            Create Strategies upto
                        </div>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            Concurrent Algo Deployment
                        </div>
                        <ng-container *ngIf="customBacktestAllowed">
                            <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                                Backtest per day
                            </div>

                            <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                                Backtest per month
                            </div>

                            <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                                Historical Backtest data [in months]
                            </div>
                        </ng-container>
                        <div class="dynamic-font-12 plans-feature-text plan-feature-alignment">
                            Multiplier for uTrade Originals
                        </div>
                    </div>
                    <div class="plans-card-action">
                        <span class="font-12">*Prices are exclusive of all taxes</span>
                    </div>
                </div>
            </div>

            <div class="plans-card-dynamic">
                <ng-container *ngFor="let plan of plansList">
                    <ng-container *ngFor="let pricing of plan.pricing_options">
                        <div class="plans-card"
                            *ngIf="shouldShowPlan(plan) && (getFrequencyValue(pricing?.duration, pricing?.frequency) === selectedTab)">
                            <div class="plans-main display-flex-column">
                                <div class="plans-card-header padding position-relative">
                                    <div class="font-20 text-accent margin-4-bottom font-bold">{{plan.plan_name}}</div>
                                    <div *ngIf="plan.level === FREE_PLAN_LEVEL; else planPricings"
                                        class="display-flex-column">
                                        <div class="font-20">
                                            <span>₹ 0.00<sup>*</sup></span>
                                        </div>
                                        <div class="font-10">
                                            <sup>*</sup>{{freePlanValidityText}}
                                        </div>
                                    </div>
                                    <ng-template #planPricings>
                                        <div class="display-flex-column">
                                            <div class="font-20">
                                                <span *ngIf="pricing.discount"
                                                    class="strike-through plans-text placeholder-text">
                                                    <span>
                                                        ₹ {{pricing.price | localeConverter:DEFAULT_PRECISION: false}}
                                                    </span>
                                                </span>
                                                <span class="font-800">
                                                    ₹ {{ (pricing.discounted_price
                                                    ? pricing.discounted_price
                                                    : getDiscountedPrice(pricing.price, pricing.discount)
                                                    ) | localeConverter:DEFAULT_PRECISION:false }}
                                                </span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <span class="plans-flags-section">
                                        <div class="plans-flag"
                                            *ngIf="(pricing.id !== downgradedPlanId || isExpired) && !isCurrentPlan(plan, pricing) && plan.id === mostPopularPlanId">
                                            <img src="/assets/images/most-popular.svg" class="plans-flag-img">
                                        </div>
                                        <div class="plans-flag" *ngIf="isCurrentPlan(plan, pricing)">
                                            <img src="/assets/images/current-plan.svg" class="plans-flag-img">
                                        </div>
                                    </span>
                                </div>
                                <div class="plans-content-container">
                                    <div class="plans-card-content round-edges margin-vr margin-right">
                                        <div
                                            class="pad-8 dynamic-font-12 plans-feature-text text-center no-border dynamic-mat-icon">
                                            <mat-icon [svgIcon]="getTick(plan, plan.live_trading)"></mat-icon>
                                        </div>
                                        <div
                                            class="pad-8 dynamic-font-12 plans-feature-text text-center dynamic-mat-icon">
                                            <mat-icon [svgIcon]="getUTradeIntelligenceTick(plan)"></mat-icon>
                                        </div>

                                        <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                            {{plan.ai_one_ai_daily_limit == MAX_SAFE_INTEGER ? 'Unlimited' :
                                            plan.ai_one_ai_daily_limit | localeConverter:DEFAULT_PRECISION: false |
                                            nullCheck}}
                                        </div>
                                        <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                            {{plan.ai_one_ai_monthly_limit == MAX_SAFE_INTEGER ? 'Unlimited' :
                                            plan.ai_one_ai_monthly_limit | localeConverter:DEFAULT_PRECISION: false |
                                            nullCheck}}
                                        </div>

                                        <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                            {{plan.forward_testing_count == MAX_SAFE_INTEGER ? 'Unlimited' :
                                            plan.forward_testing_count | localeConverter:DEFAULT_PRECISION: false |
                                            nullCheck}}
                                        </div>

                                        <div
                                            class="pad-8 dynamic-font-12 plans-feature-text text-center dynamic-mat-icon">
                                            <span *ngIf="!getuTradeOriginalAllowed(plan); else showCount">
                                                <mat-icon svgIcon="cancel"></mat-icon>
                                            </span>
                                            <ng-template #showCount>
                                                <span>{{ getMarketCount(plan) }}</span>
                                            </ng-template>
                                        </div>
                                        <div *ngIf="getPlanSymbols(plan.id, Exchange.NSE); else noSymbol" #NSEPlan
                                            class="pad-8 dynamic-font-12 plans-feature-text text-center cursor-pointer"
                                            (click)="toggleEllipsis(true,NSEPlan)"
                                            [ngClass]="{'overflow-ellipsis':showNseEllipsis}">
                                            {{ getPlanSymbols(plan.id, Exchange.NSE) | nullCheck}}
                                        </div>
                                        <div *ngIf="getPlanSymbols(plan.id, Exchange.BSE); else noSymbol" #BSEPlan
                                            class="pad-8 dynamic-font-12 plans-feature-text text-center cursor-pointer"
                                            (click)="toggleEllipsis(false,BSEPlan)"
                                            [ngClass]="{'overflow-ellipsis':showBseEllipsis}">
                                            {{getPlanSymbols(plan.id, Exchange.BSE) | nullCheck}}
                                        </div>
                                        <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                            {{plan.max_saved_algo == MAX_SAFE_INTEGER ? 'Unlimited' :
                                            plan.max_saved_algo |
                                            localeConverter:DEFAULT_PRECISION: false | nullCheck}}
                                        </div>
                                        <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                            {{plan.max_active_algo == MAX_SAFE_INTEGER ? 'Unlimited' :
                                            plan.max_active_algo
                                            | localeConverter:DEFAULT_PRECISION: false | nullCheck}}
                                        </div>
                                        <ng-container *ngIf="customBacktestAllowed">
                                            <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                                {{plan.backtest_per_day == MAX_SAFE_INTEGER ? 'Unlimited' :
                                                plan.backtest_per_day | localeConverter:DEFAULT_PRECISION: false |
                                                nullCheck}}
                                            </div>
                                            <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                                {{plan.backtest_per_month == MAX_SAFE_INTEGER ? 'Unlimited' :
                                                plan.backtest_per_month | localeConverter:DEFAULT_PRECISION: false |
                                                nullCheck}}
                                            </div>

                                            <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                                {{plan.backtest_data == MAX_SAFE_INTEGER ? 'Unlimited'
                                                : plan.backtest_data | localeConverter:DEFAULT_PRECISION: false |
                                                nullCheck}}
                                            </div>
                                        </ng-container>

                                        <div class="pad-8 dynamic-font-12 plans-feature-text text-center">
                                            {{plan.max_multiplier == MAXIMUM_MULTIPLIER_UNLIMITED ? 'Unlimited' : 'Upto
                                            ' +
                                            plan.max_multiplier + 'X'}}
                                        </div>
                                    </div>
                                </div>

                                <div class="plans-card-action">
                                    <button mat-stroked-button class="plans-action-btn border-radius-8" disabled
                                        *ngIf="isCurrentPlan(plan, pricing); else subscribeButton">
                                        Current Plan
                                    </button>
                                    <ng-template #subscribeButton>
                                        <button mat-stroked-button class="plans-action-btn border-radius-8"
                                            *ngIf="(plan.id !== defaultPlanId) && (plan.level !== FREE_PLAN_LEVEL)"
                                            [class.new-submit-button]="!isPlanDowngradable(plan.level, pricing)"
                                            [disabled]="subscribingPricingId !== null"
                                            (click)="subscribePlan(pricing.id)">
                                            {{subscribingPricingId === pricing.id ? 'Redirecting...' :
                                            (isPlanDowngradable(plan.level, pricing) ? 'Subscribe' : 'Upgrade')}}
                                        </button>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <div class="plans-card new-plan-card fill-height" *ngIf="showNewPlanCard">
                    <div class="plans-main display-flex-column fill-height">
                        <div class="plans-card-header padding"></div>
                        <div class="plans-content-container">
                            <div class="plans-card-content round-edges margin-vr margin-right">
                                <div class="new-plan-card-content">
                                    <img src="/assets/images/briefcase.svg" class="new-plans-icon">
                                    <span class="font-16">New Plans Coming Soon!</span>
                                </div>
                            </div>
                        </div>
                        <div class="plans-card-action">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Dummy component to elevate height -->
        <div class="padding-bottom full-width" *ngIf="!isDialog"></div>
    </ng-container>
</ng-container>

<ng-template #plansFrequencyRadio>
    <mat-radio-group class="plans-frequency-radio" [(ngModel)]="selectedTab">
        <mat-radio-button class="plans-frequency-radio-button border-radius-4 pad-6 border-fg-accent" *ngFor="let frequency of frequencyArray"
            [value]="frequency">
            <span class="font-12 fg-accent">{{ frequency }}</span>
        </mat-radio-button>
    </mat-radio-group>
</ng-template>


<ng-template #noSymbol>
    <div class="pad-8 dynamic-font-12 plans-feature-text text-center dynamic-mat-icon">
        <mat-icon svgIcon="cancel"></mat-icon>
    </div>
</ng-template>

<ng-template #loader>
    <app-plans-loading></app-plans-loading>
</ng-template>

<ng-template #statusScreen>
    <app-plans-status [status]="currentStatus" [isDialog]="isDialog" (goBack)="resetStatusScreen()">
    </app-plans-status>
</ng-template>

<ng-template #noOffersHeader>
    <div *ngIf="isDialog" class="font-16 font-bold"> Manage Plans </div>
</ng-template>